export default "__VITE_ASSET__76b2a2a8__"